import SelectTag from "./select_tag";

export default class SelectTagWithLinkChange extends SelectTag {
  constructor(node) {
    super(node);

    this.linkButtons = document.querySelectorAll(".js-select-link-button");
  }

  handleSelectTagClick(e) {
    const { target } = e;

    const selectValue = target.querySelector(".js-select-value");
    const input = target.querySelector("input");

    if (selectValue) {
      this.updateLink(input);

      this.element.dispatchEvent(new CustomEvent("available-languages-updated", { detail: input.dataset.availableLanguages }));
      this.updateHtml(input.value, selectValue.innerHTML);
      this.inputElement.dispatchEvent(new Event("change"));
      input.checked = true;
      input.dispatchEvent(new Event("change"));
    }

    this.toggleDropdown();
  }

  updateHtml(inputValue, selectValue) {
    this.selectedValue.innerHTML = selectValue;
    this.inputElement.value = inputValue;
  }

  updateLink({ name, value }) {
    this.linkButtons.forEach((linkButton) => {
      const url = new URL(linkButton.href);

      url.searchParams.set(name, value);
      linkButton.href = url;
    });
  }

  updateAvailableOptions(valuesArray) {
    this.element.parentNode.classList.toggle("d-none", valuesArray[0] == "");

    const labels = this.dropdownElement.querySelectorAll("label");
    labels.forEach((label) => {
      label.classList.toggle("d-none", !valuesArray.includes(label.getAttribute("for")));
    });
  }
}
